import { useCallback, useEffect, useState } from 'react';
// material
import {
  Card,
  Checkbox,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@mui/material';
import { Box } from '@mui/system';
import { useDispatch } from 'react-redux';
// components
import BrudCrumbs from '../../components/BreadCrumbs';
import Label from '../../components/Label';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserMoreMenu } from '../../components/_dashboard/user';
import { fDate, fDateNew } from '../../utils/formatTime';
import { NOT_AVAILABLE } from '../Global/Constants';
import SalesToolbar from './SalesToolbar';
import { getPayoutList } from '../../store/Slice/Payout/PayoutSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import { isValidValue, normalizeValue, truncateText } from '../../utils/CommonFunction';
import usePayoutSelector from '../../store/Slice/Payout/PayoutSelector';
import { getMasterListType } from '../../store/Slice/Global/GlobalSlice';
import { StyledTableCell, StyledTableRow } from '../../utils/StyleTable';
import { getMatchedDownloadList, getSalesList } from '../../store/Slice/Sales/SalesSlice';
import useSalesSelector from '../../store/Slice/Sales/SalesSelector';
import SimplePagination from '../../components/SimplePagination';
import useDebounce from '../../utils/useDebounce';

const TABLE_HEAD = [
  { id: 'leadId', label: 'Application Id', alignRight: false },
  { id: 'fileNumber', label: 'Reference Number', alignRight: false },
  { id: 'partnerName', label: 'Partner', alignRight: false },
  { id: 'created', label: 'Submission Date', alignRight: false },
  { id: 'bankName', label: 'Bank', alignRight: false },
  { id: 'city', label: 'City', alignRight: false },
  { id: 'name', label: 'Borrower Name', alignRight: false },
  { id: 'loanType', label: 'Loan Type', alignRight: false },
  { id: 'monthName', label: 'Disb Month', alignRight: false },
  // { id: 'invoiceNo', label: 'LAN', alignRight: false },
  { id: 'amount2', label: 'Disbursed Amount', alignRight: false },
  { id: 'payoutStatus', label: 'Status', alignRight: false },
  { id: 'created', label: 'Last update', alignRight: false }
  // { id: 'action', label: 'ACTION' }
];

export default function SalesList() {
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [order, setOrder] = useState('desc');
  const [page1, setPage1] = useState(1);
  const [selectStatus, setSelectStatus] = useState(288);
  const [downloadPopup, setDownloadPopup] = useState(false);
  const [filterParameter, setFilterParameter] = useState({
    bankId: null
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [hasNextPage, setHasNextPage] = useState(true);

  const dispatch = useDispatch();
  const { LoginData } = useLoginSelector();
  const { SalesListData } = useSalesSelector();
  const debouncedSearch = useDebounce(filterName, 600);

  // console.log('sss SalesListData', SalesListData);

  const handleRequestSort = (event, property) => {
    if (property !== 'action') {
      setOrder(orderBy === property && order === 'asc' ? 'desc' : 'asc');
      setOrderBy(property);
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = SalesListData?.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - SalesListData.length) : 0;

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  // Master Type List
  const getMasterTypeListApi = () => {
    const type = 'PAYOUT_STATUS_TYPE';
    dispatch(getMasterListType(type));
  };
  const handleDownloadMatchDetails = async () => {
    const credentials = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      accessLevelId: LoginData?.accessLevelId,
      entityListRequestModel: {},
      filterModel: {
        bankId: filterParameter?.bankId || null
      },
      filterPayoutStatusId: isValidValue(selectStatus) ? selectStatus : null
    };

    const res = await dispatch(getMatchedDownloadList(credentials));
    console.log('sss CSV API response', res);

    if (!res || !res.success || !res.data) {
      console.error('❌ No CSV data found!');
      return;
    }

    const csvText = String(res.data); // 👈 ensure it's a string

    try {
      const blob = new Blob([`\uFEFF${csvText}`], {
        type: 'text/csv;charset=utf-8;'
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Sales${selectStatus === 260 ? 'MisMatched' : 'Matched'}Report.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download error:', err);
    } finally {
      setDownloadPopup(false);
    }
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const getPayoutListApi = useCallback(() => {
    const credentials = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      accessLevelId: LoginData?.accessLevelId,
      entityListRequestModel: {
        pageNumber: page + 1,
        pageSize: rowsPerPage,
        searchLiteral: debouncedSearch?.length >= 2 ? debouncedSearch : null,
        sortOrder: order
      },
      filterModel: {
        bankId: filterParameter?.bankId || null
      },
      filterPayoutStatusId: isValidValue(selectStatus) ? selectStatus : null
    };
    // console.log('🔎 filterParameter', filterParameter);
    // console.log('📤 credentials sending to API:', JSON.stringify(credentials, null, 2));
    const result = dispatch(getSalesList(credentials));
    // console.log('result2222', result);
  }, [
    LoginData,
    page1,
    rowsPerPage,
    debouncedSearch,
    order,
    selectStatus,
    filterParameter,
    page,
    dispatch
  ]);

  useEffect(() => {
    getPayoutListApi();
  }, [getPayoutListApi]);

  useEffect(() => {
    getMasterTypeListApi();
  }, []);

  useEffect(() => {
    // whenever filters change, go to first page
    setPage1(1);
  }, [filterParameter, selectStatus, debouncedSearch]);
  useEffect(() => {
    if (!SalesListData) {
      setHasNextPage(true);
      return;
    }
    // If API returned fewer rows → last page
    setHasNextPage(SalesListData.length >= rowsPerPage);
  }, [SalesListData, rowsPerPage]);

  useEffect(() => {
    setPage(0);
  }, [debouncedSearch, selectStatus]);

  return (
    <Page title="Partner Management System || Sales List">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Sales List" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Card>
            <SalesToolbar
              parent="payout"
              selectStatus={selectStatus}
              setSelectStatus={setSelectStatus}
              handleDownloadMatchDetails={handleDownloadMatchDetails}
              setDownloadPopup={setDownloadPopup}
              downloadPopup={downloadPopup}
              onFilterName={handleFilterByName}
              setFilterParameter={setFilterParameter}
              filterParameter={filterParameter}
              filterName={filterName}
            />
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800, height: '50vh', overflow: 'auto' }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={SalesListData?.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                    parent="sales"
                    // isCheckBox="true"
                  />
                  {/* {console.log('SalesListData2222', SalesListData)} */}
                  <TableBody>
                    {SalesListData?.length > 0 &&
                      SalesListData?.map((item, index) => {
                        const isItemSelected = selected.indexOf(item) !== -1;

                        return (
                          <StyledTableRow
                            hover
                            key={index}
                            tabIndex={-1}
                            role="checkbox"
                            selected={isItemSelected}
                            aria-checked={isItemSelected}
                          >
                            {/* <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                onChange={(event) => handleClick(event, item)}
                              />
                            </TableCell> */}
                            <StyledTableCell align="left" style={{ paddingLeft: '25px' }}>
                              {normalizeValue(item?.applicationId, NOT_AVAILABLE)}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {truncateText(normalizeValue(item?.fileNumber, NOT_AVAILABLE), 15)}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {normalizeValue(item?.partnerName, NOT_AVAILABLE)}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {isValidValue(item?.fileSubmissionDate)
                                ? fDate(item?.fileSubmissionDate)
                                : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {normalizeValue(item?.bankName, NOT_AVAILABLE)}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {normalizeValue(item?.cityName, NOT_AVAILABLE)}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {normalizeValue(item?.borrowerName, NOT_AVAILABLE)}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {normalizeValue(item?.loanTypeName, NOT_AVAILABLE)}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {normalizeValue(fDateNew(item?.disburseMonth), NOT_AVAILABLE)}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {normalizeValue(item?.disburseAmount, NOT_AVAILABLE)}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              <Label
                                variant="ghost"
                                color={
                                  (item?.payoutStatus &&
                                    item?.payoutStatus === 'Not Matched' &&
                                    'error') ||
                                  (item?.payoutStatus &&
                                    item?.payoutStatus === 'MIS' &&
                                    'warning') ||
                                  (item?.payoutStatus &&
                                    item?.payoutStatus === 'Invoice' &&
                                    'warning') ||
                                  (item?.payoutStatus &&
                                    item?.payoutStatus === 'Payment Due' &&
                                    'error') ||
                                  (item?.payoutStatus &&
                                    item?.payoutStatus === 'Paid' &&
                                    'success') ||
                                  'success'
                                }
                              >
                                {item?.payoutStatus ? item?.payoutStatus : `${NOT_AVAILABLE}`}
                              </Label>
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {isValidValue(item?.lastUpdated)
                                ? fDate(item?.lastUpdated)
                                : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            {/* <StyledTableCell align="" width={80}>
                              <UserMoreMenu rowId={item} parent="sales" />
                            </StyledTableCell> */}
                          </StyledTableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <StyledTableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                  {SalesListData?.length === 0 && (
                    <TableBody>
                      <TableRow>
                        <StyledTableCell
                          align="center"
                          colSpan={TABLE_HEAD.length + 1}
                          sx={{ py: 3 }}
                        >
                          <SearchNotFound searchQuery={filterName} />
                        </StyledTableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>
            <SimplePagination page={page} setPage={setPage} hasNextPage={hasNextPage} />
          </Card>
        </Box>
      </Container>
    </Page>
  );
}
